import { environment } from '../../../environments/environment';

const packageServiceServicePath = '/package';
const countryServiceServicePath = '/appvalue/COUNTRY';
const editServicePath = "/package/{id}";
const rateCardServicePath = '/ratecard';

export const PackageServicePathConst = `${environment.api}${packageServiceServicePath}`;
export const CountryServicePathConst = `${environment.api}${countryServiceServicePath}`;
export const RateCardServicePathConst = `${environment.api}${rateCardServicePath}`;
export const EditServicePathConst = `${environment.api}${editServicePath}`;
